import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Permissions for guarding entity convert limits.
 */
export const ENTITY_CONVERT_LIMITS_ENABLED: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [Role.EXCHANGE_ROLE],
}
